
export default class Draw{
    constructor(){

    }
    // 添加文字标签
    addLabel(params){
        let {
            text = '',
            name = "",
            position = {},
            font,
            color = '#FF4500',
            imgShow = false,
            // image = require('../../../assets/img/floornor.png'),
            textShow = true,
            pixelOffset = [0,0]
        } = params
        let label = viewer.entities.add({
            name,
            position:new Cesium.Cartesian3.fromDegrees(position.lon, position.lat, position.alt),
            label:{
                text,
                font,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                fillColor:Cesium.Color.WHITE,
                backgroundColor: Cesium.Color.fromCssColorString('#375577').withAlpha(0.0), //背景颜色
                showBackground: true, //是否显示背景颜色
                style:Cesium.LabelStyle.FILL,
                verticalOrigin:Cesium.VerticalOrigin.CENTER,
                horizontalOrigin:Cesium.HorizontalOrigin.CENTER,
                pixelOffset:new Cesium.Cartesian2(pixelOffset[0], pixelOffset[1]),
                scale:1,
                // translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.2), //随距离改变透明度
                distanceDisplayCondition: new Cesium.DistanceDisplayCondition(1, 800), //x米之内，y米之外不显示
                scaleByDistance:new Cesium.NearFarScalar( 10, 1.5, 800, 0.2), //随距离改变大小
                // outline:true,
                // outlineColor:Cesium.Color.ORANGE,
                // outlineWidth:100,
                show:textShow
            },
            // billboard:{
            //     image,
            //     scale:1,
            //     disableDepthTestDistance: Number.POSITIVE_INFINITY, //应用深度测试
            //     verticalOrigin: Cesium.VerticalOrigin.CENTER, //广告牌垂直原点
            //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //广告牌水平原点
            //     //sizeInMeters : true, //图像的尺寸被指定成图像实际的尺寸
            //     scaleByDistance: new Cesium.NearFarScalar( 10, 2, 500, 0.4), //随距离改变大小
            //     // translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.2), //随距离改变透明度
            //     distanceDisplayCondition: new Cesium.DistanceDisplayCondition(1, 800), //x米之内，y米之外不显示
            //     show:imgShow
            // }
        })
        return label
    }
    
    addPoint(params){
        let {
            name = 'point',
            position = {},
            text = '起点',
            labelShow = true
        } = params
        console.log(position)
        let point = viewer.entities.add({
            name ,
            position:Cesium.Cartesian3.fromDegrees(position.lon, position.lat, position.alt),
            point:{
                pixelSize:10,
                color:Cesium.Color.ORANGE,
                outlineColor:Cesium.Color.WHITE,
                outlineWidth:2,
                // heightReference:position.alt,
                // scaleByDistance:new Cesium.NearFarScalar( 10, 2, 500, 0.4), //随距离改变大小
                // translucencyByDistance:new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.2), //随距离改变透明度
                // distanceDisplayCondition:new Cesium.DistanceDisplayCondition(0.0, 2000), // 2000米内显示 ，2000米外不显示 
                // disableDepthTestDistance:Number.POSITIVE_INFINITY 
                disableDepthTestDistance:50000
            },
            label:{
                text,
                font:'14pt monospace', // 文字字体 
                style:Cesium.LabelStyle.FILL_AND_OUTLINE,
                fillColor:Cesium.Color.ORANGE,  
                // heightReference:position.alt,       // 指定高度相对的高度
                outlineWidth:2,    // 此标签的填充颜色
                outlineColor:Cesium.Color.WHITE,
                scale: 1,
                show:labelShow,
                backgroundColor:Cesium.Color.BLACK, // 标签背景色
                showBackground:true,
                verticalOrigin:Cesium.VerticalOrigin.BOTTOM, //垂直方向上标签的位置
                pixelOffset:new Cesium.Cartesian2(0, -20) , // 偏移量
                // scaleByDistance:new Cesium.NearFarScalar( 10, 2, 500, 0.4), //随距离改变大小
                // translucencyByDistance:new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.2), //随距离改变透明度
                // distanceDisplayCondition:new Cesium.DistanceDisplayCondition(2000, 3000) // 2000到3000米内显示 
                disableDepthTestDistance:50000
            }
        })

        return point
    }


    // 广告牌
    addBillboard(params){
        let {
            name = "",
            position = {},
            image,
            scale,
        }  = params
        let billboard = viewer.entities.add({
            name,
            position:Cesium.Cartesian3.fromDegrees(position.lon, position.lat, position.alt),
            billboard:{
                image,
                scale,
                disableDepthTestDistance: Number.POSITIVE_INFINITY, //应用深度测试
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //广告牌垂直原点
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //广告牌水平原点
                //sizeInMeters : true, //图像的尺寸被指定成图像实际的尺寸
                scaleByDistance: new Cesium.NearFarScalar( 10, 2, 500, 0.4), //随距离改变大小
                // translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.2), //随距离改变透明度
                distanceDisplayCondition: new Cesium.DistanceDisplayCondition(1, 800), //x米之内，y米之外不显示
                show:true
            }
        })
        return billboard
    }

    // 添加平面多边形图形 
    addPlane(params) {
        let {
            plane = [],
            name = '多边形'
        } = params
        let polygonGraphic = viewer.entities.add({
            name,
            polygon:{
                hierarchy:Cesium.Cartesian3.fromDegreesArrayHeights(plane),
                outline:false,
                outlineColor:Cesium.Color.ORANGE,
                outerWidth:2,
                material:Cesium.Color.fromCssColorString('#ADD8E6').withAlpha(0.3),
                full:true,
                // height:height ,
                show:true,
                disableDepthTestDistance:50000
            }
        });
        return polygonGraphic
    }

    // 墙体
    addWall(params){
        let { 
            positions = [],
            wallHeights = [],
            image
        } = params
        let wall = viewer.entities.add({
            wall:{
                positions:Cesium.Cartesian3.fromDegreesArrayHeights(positions),
                minimumHeights:wallHeights,
                material:new Cesium.ImageMaterialProperty({
                    image,
                    transparent:true,
                    color:new Cesium.CallbackProperty(play, false)
                })
            },
            show:true
        })
        let alp = 0.4
        let numflag = 0
        function play(){
            if ((numflag % 2) === 0) {
                alp += 0.01;
            } else {
                alp -= 0.01;
            }

            if (alp <= 0.4) {
                numflag++;
            } else if (alp >= 1) {
                numflag--;
            }
            return Cesium.Color.AQUA.withAlpha(alp)
        }

        return wall
    }
    // 画盒子
    addSpace(params){
        let { 
            name = "",
            positions = [],
            height,
            color,
            lineColor,
            show = true
        } = params
        let space = viewer.entities.add({
            name,
            polygon:{
                hierarchy:Cesium.Cartesian3.fromDegreesArrayHeights(positions),
                extrudedHeight:height,
                disableDepthTestDistance: Number.POSITIVE_INFINITY, //应用深度测试
                perPositionHeight: true,
                material: color,
                outline: true,
                outlineColor: lineColor,
                distanceDisplayCondition: new Cesium.DistanceDisplayCondition(1, 800), //x米之内，y米之外不显示
                show,
            }
        })
        return space
    }

    // 画线
    addLine(params){
        let {
            name = "",
            positions = [],

        } = params
        let line = viewer.entities.add({
            name,
            polyline:{
                positions:Cesium.Cartesian3.fromDegreesArrayHeights(positions),
                width:1,
                // material : new Cesium.PolylineOutlineMaterialProperty({
                    // color : Cesium.Color.WHITE,
                    // outlineWidth : 1,
                    // outlineColor : Cesium.Color.BLACK
                // }),
                material:Cesium.Color.WHITE,
                distanceDisplayCondition: new Cesium.DistanceDisplayCondition(1, 800), //x米之内，y米之外不显示
                disableDepthTestDistance:50000
            }
        })
        return line
    }

    addEllipse(data){
        let {
            name = '',
            position = {},
            min = 2,
            max = 2,
            maxNum = 10,
            height = 0
        } = data
        function changeCircle(){
            
            min += 0.05
            if(min >= maxNum){
                min = 0.5
            }
            return min
        }
        function changeCircle1(){
            
            max += 0.05
            if(max >= maxNum){
                max = 0.5
            }
            return max
        }
        
        function changeAph(){
            let aph =1 -   max / maxNum
            return Cesium.Color.ORANGE.withAlpha(aph)
        }

        let circle = viewer.entities.add({
            name,
            position:Cesium.Cartesian3.fromDegrees(position.lon, position.lat,position.alt),
            // id,
            ellipse:{
                semiMajorAxis : new Cesium.CallbackProperty(changeCircle1, false),
                semiMinorAxis : new Cesium.CallbackProperty(changeCircle, false),
                material:new Cesium.ColorMaterialProperty(new Cesium.CallbackProperty(changeAph,false)),
                // material: new Cesium.ImageMaterialProperty({
                //     image:require("../../assets/logo.png"),
                //     repeat:new Cesium.Cartesian2(1.0, 1.0),
                //     transparent:true,
                //     // color:new Cesium.CallbackProperty(changeAph,false)
                // }),
                show:false,
                extrudedHeight:height,  //高度
                height: height, //浮空
                // material : Cesium.Color.GREEN,
                outlineColor:Cesium.Color.BLACK,
            },
        })

        return circle
    }
}